<div [formGroup]="pinForm" class="flex gap-3 justify-center">
  <ng-container formArrayName="digits">
    <input
      *ngFor="let control of digits.controls; let i = index"
      #inputs
      class="w-[42px] h-12 rounded-lg text-center text-xl font-bold bg-neutrals-200 border-1 border-neutrals-200 outline-none transition-colors"
      [ngClass]="{
        'border-critical-300 text-critical-300 bg-[#FFF1F2]': hasError,
        'border-neutrals-500': control.value && !hasError,
        'focus:border-blue-500 focus:outline-none focus:border-2': !hasError,
      }"
      type="tel"
      inputmode="numeric"
      pattern="[0-9]*"
      [formControl]="getControl(i)"
      maxlength="1"
      (input)="onInput(i, getControl(i))"
      (keydown)="onKeydown(i, getControl(i), $event)"
    />
  </ng-container>
</div>
